import script from "./Appfooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./Appfooter.vue?vue&type=script&setup=true&lang=ts"

import "./Appfooter.vue?vue&type=style&index=0&id=9e9ca7a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e9ca7a2"]])

export default __exports__